import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from './Icons';
export function AudienceSection() {
  return <section className="w-full bg-white-soft py-10 md:py-24 px-5" data-id="element-21">
      <div className="max-w-2xl mx-auto" data-id="element-22">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-2xl md:text-3xl font-bold text-brown-dark text-center mb-7 md:mb-12" data-id="element-23">
          ¿Es para ti?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-24">
          {/* For you */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-sage-light/50 rounded-xl p-6 md:p-8 border border-sage/15" data-id="element-25">
            <h3 className="font-heading text-xl font-bold text-sage-dark mb-6" data-id="element-26">
              Esto Es Para Ti Si...
            </h3>

            <ul className="space-y-4" role="list" data-id="element-27">
              <li className="flex gap-3 items-start" data-id="element-28">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-29" />
                <span className="font-body text-base text-brown-medium leading-relaxed" data-id="element-30">
                  Eres mujer de 60+ (o 35+ con síntomas prematuros) y ves tu
                  cuero cabelludo transparentarse.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-31">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-32" />
                <span className="font-body text-base text-brown-medium leading-relaxed" data-id="element-33">
                  Sufres de picazón, ardor o sensibilidad en el cuero cabelludo.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-34">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-35" />
                <span className="font-body text-base text-brown-medium leading-relaxed" data-id="element-36">
                  Has probado lociones y vitaminas sin ver ningún cambio real.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-37">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-38" />
                <span className="font-body text-base text-brown-medium leading-relaxed" data-id="element-39">
                  Buscas una solución natural, económica y basada en la biología
                  de la piel.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Not for you */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-200" data-id="element-40">
            <h3 className="font-heading text-xl font-bold text-warm-gray mb-6" data-id="element-41">
              Esto NO Es Para Ti Si...
            </h3>

            <ul className="space-y-4" role="list" data-id="element-42">
              <li className="flex gap-3 items-start" data-id="element-43">
                <XCircleIcon className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-44" />
                <span className="font-body text-base text-warm-gray leading-relaxed" data-id="element-45">
                  Tienes pérdida de cabello por tratamientos de quimioterapia
                  activos.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-46">
                <XCircleIcon className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-47" />
                <span className="font-body text-base text-warm-gray leading-relaxed" data-id="element-48">
                  Buscas una "cura milagrosa" de la noche a mañana sin seguir el
                  protocolo de 7 días.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-49">
                <XCircleIcon className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-50" />
                <span className="font-body text-base text-warm-gray leading-relaxed" data-id="element-51">
                  Tienes alopecia cicatricial donde el folículo ha sido
                  reemplazado totalmente por tejido fibroso.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}